

import React, { useState, useRef, useEffect } from "react";
import { FaEye, FaTrash } from "react-icons/fa";
import { FaAngleLeft, FaAngleRight, FaPencil } from "react-icons/fa6";
import axios from "axios";
import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { getPageNumbers } from "../Utility/pagination";
import { handleAxiosError } from "../Utility/handleAxiosError";

const RegistrationFilter = () => {
  const [notifications, setNotifications] = useState([]);
  const [locations, setLocations] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [viewNotifications, setViewNotifications] = useState([]); 
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); 
    const [totalItems, setTotalItems] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [rank, setRank] = useState([]);
const location = useLocation();
  const status= location.state?.status

  const [filters, setFilters] = useState({
      fullName: "",
      forceNumber: "",
      rank: "",
      status: "",
    });
    useEffect(() => {
      if (status) {
        setFilters((prev) => ({
          ...prev,
          status: status,
        }));
      }
    }, [status]);


     useEffect(() => {
    const fetchUsers = async () => {
      dispatch(isloading());
      try {
        const res = await AxiosInstance.get("/api/dashboard/district/applications", {
          params: filters,
        });
        setNotifications(res.data.data);
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        dispatch(isloading());
      }
    };
    fetchUsers();
  }, [filters]);

  const fetchLinks = async (pageNumber = currentPage) => {
    const backendPage = pageNumber - 1;
    setSearchQuery("");
    setCurrentPage(1);
    const token = sessionStorage.getItem("userToken");
    if (!token) return navigate("/login");
      dispatch(isloading());
    try {
    //   const resLocation = await AxiosInstance.get(
    //     `${BaseUrl}/api/master/notificationType`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: token,
    //       },
    //     }
    //   );

    //   if (resLocation.data.status === 200) {
    //     const locationTypes = resLocation.data.data.map((item) => item.type);
    //     setLocations(locationTypes);
    //   } else {
    //     toast.error("Failed to fetch locations.");
    //   }

    //   const res = await AxiosInstance.post(
    //     `${BaseUrl}/api/notifications/getNotification`,
    //     { location: "All" },
    //     {
    //       headers: { "Content-Type": "application/json", Authorization: token },
    //       params: {
    //         page: backendPage,
    //         size: itemsPerPage,
    //       },
    //     },
         
    //   );

    //   if (res.data.status === 200) {
    //     setNotifications(
    //       res.data.data.content.map((img) => ({
    //         id: img.key,
    //         title: img.title,
    //         file: `data:application/pdf;base64,${img.file}` || "",
    //         location: img.location,
    //       }))
    //     );

    //     setTotalPages(res.data.data.totalPages);
    //     setTotalItems(res.data.data.totalItems);
    //     setCurrentPage(pageNumber);
    //   } else {
    //     toast.error("Failed to fetch links.");
    //   }


    const res = await AxiosInstance.get(
        `${BaseUrl}/api/dashboard/district/applications`,
        {
            params:{status:`${status}`}
        }
      );

      setNotifications(res.data.data)

      const resRank = await AxiosInstance.get(`${BaseUrl}/api/dashboard/ranks`);
      setRank(resRank.data);
    } catch (error) {
       handleAxiosError(error);
    } finally {
        dispatch(isloading());
    }
  };

  useEffect(() => {
    fetchLinks();
  }, []);

  useEffect(() => {
    setViewNotifications(notifications);
    }, [notifications]);

 const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

    const handlePageChange = (pageNumber) => {
      if (pageNumber > 0 && pageNumber <= totalPages) {
      fetchLinks(pageNumber);
    }
    };
  
    const handleNextPage = () => {
           handlePageChange(currentPage + 1);
          };
  
    const handlePreviousPage = () => {
         handlePageChange(currentPage - 1);
     };

  const [newNotification, setNewNotification] = useState({});
  const fileInputRef = useRef(null);
  const [currentNotification, setCurrentNotification] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editLink, setEditLink] = useState("");
  const [currentEditId, setCurrentEditId] = useState("");
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleView = async (documentId) => {
  const notification = notifications.find((item) => item.id === documentId);
  const token = sessionStorage.getItem("userToken");

  try {

      const response = await fetch(`${BaseUrl}/api/notifications/document/${documentId}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });
    
    if (!response.ok) {
      if (response.status === 404) {
        toast.error("Document not found.");
      } else {
        toast.error("Failed to load the document.");
      }
      return;
    }

    const blob = await response.blob();
    const fileUrl = URL.createObjectURL(blob);

    setCurrentNotification({
      ...notification,
      file: fileUrl,
    });

    setIsViewModalOpen(true);
  } catch (error) {
    console.error("Error loading file:", error);
    toast.error("An unexpected error occurred while opening the document.");
  }
};

  // Edit Notification
  const handleEdit = (notification) => {
    // setCurrentNotification(notification);
    navigate("/dashboard/admin-registration-data",{state:{data:notification}})

    // setEditTitle(notification.title);
    // setEditLink(notification.link);
    // setCurrentEditId(notification.id);
    // setIsEditModalOpen(true);
  };


  const handleTitleChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      title: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["application/pdf"];
      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload an PDF.");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        toast.error("File size exceeds 1MB.");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setNewNotification((prevState) => ({ ...prevState, file }));
    }
  };
  const handleInputChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      link: e.target.value,
    }));
  };


  const handleSave = async () => {
    if (
      newNotification.title &&
      newNotification.file &&
      newNotification.location
    ) {
      const token = sessionStorage.getItem("userToken");
     

      const formData = new FormData();
      formData.append("multipart", newNotification.file);
      formData.append("title", newNotification.title);
      formData.append("location", newNotification.location);
      formData.append("link", newNotification.link);
        dispatch(isloading());
      try {
        const res = await axios.post(
          `${BaseUrl}/api/notifications/create`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/formData",
              Authorization: token,
            },
          }
        );

        if (res.data.status === 200) {
          
          toast.success(res.data.message);

         fetchLinks();
        } else {
          toast.error(res.data.message);
        }

     
        setNewNotification({ title: "", file: null, location: "", link: "" });
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; 
        }
      } catch (error) {
        toast.error("Error creating the notification.");
        setNewNotification({ title: "", file: null, location: "", link: "" });
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; 
        }
      } finally {
          dispatch(isloading());
      }
    } else {
      toast.error("Please fill in the title, location and upload pdf");
    }
  };

  const handleEditSave = async () => {
    if (editTitle.trim() === "") {
      toast.error("Title cannot be empty.");
      return;
    }

    if (!currentNotification.location) {
      toast.error("Location cannot be empty.");
      return;
    }

    const token = sessionStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("title", editTitle);
    formData.append("key", currentEditId);
    formData.append("location", currentNotification.location);
    formData.append("link", editLink);

    if (fileInputRef.current.files[0]) {
      const file = fileInputRef.current.files[0];
      const validTypes = ["application/pdf"];

      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload a PDF.");
        fileInputRef.current.value = ""; // Reset file input
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        toast.error("File size exceeds 1MB.");
        fileInputRef.current.value = "";
        return;
      }
      formData.append("multipart", file);
    } else {
      toast.error("File cannot be empty.");
      return;
    }
     dispatch(isloading());
    try {
      const res = await axios.post(
        `${BaseUrl}/api/notifications/updateNotification`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        }
      );

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchLinks(); // Refresh notifications list
        setIsEditModalOpen(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error updating the notification.");
    } finally {
      dispatch(isloading());
    }
  };

  const handleLocationChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      location: e.target.value,
    }));
  };


  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    
    // Filter links based on search query (title, location, or link)
    const filteredLinks = notifications.filter(
      (link) =>
        link.title.toLowerCase().includes(query) ||
        link.location.toLowerCase().includes(query) 
    );
  
    setTotalItems(filteredLinks.length);
    setCurrentPage(1); // Reset to first page
    setViewNotifications(filteredLinks.slice(0, itemsPerPage));
  };
  return (
   
        <div className="home-dashboard">
         
          <div className="ticket-tab">
           
            <div className="row mb-4">
            <div className="col-6"> 
                <h3>Registered Users</h3>
                  </div>
                  </div>
    
        
        <div className="row g-2 mb-3">
          <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              placeholder="Full Name"
              value={filters.fullName}
              onChange={(e) =>
                setFilters({ ...filters, fullName: e.target.value })
              }
            />
          </div>

          <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              placeholder="Force No."
              value={filters.forceNumber}
              onChange={(e) =>
                setFilters({ ...filters, forceNumber: e.target.value })
              }
            />
          </div>

          <div className="col-md-3">
            <select
              className="form-select"
              value={filters.rank}
              onChange={(e) => setFilters({ ...filters, rank: e.target.value })}
            >
              <option value="">Select Rank</option>
              {rank?.map((rankItem, index) => (
                <option key={index} value={rankItem}>
                  {rankItem}
                </option>
              ))}
            </select>
          </div>

          

          <div className="col-md-3">
            <select
              className="form-select"
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
            >
              <option value="">Select Status</option>
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Approved</option>
              <option value="REJECTED">Rejected</option>
            </select>
          </div>
        </div>
      
      <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <thead>


                <tr>
                <th>Name </th>
                <th>Rank </th>
                <th>Force Number </th>
                <th>District </th>
                <th>Mobile </th>
                <th >Action</th>
              </tr>
            </thead>
            <tbody>
              
                {viewNotifications.length > 0 ? (
                  viewNotifications.map((notification) => (
                    <tr key={notification.id}>
                      <td>{notification.fullName}</td>
                      <td>{notification.rank}</td>
                      <td>{notification.forceNumber}</td>
                      <td>{notification.district}</td>
                      <td>{notification.mobile}</td>
                      <td>
                       
                        {notification.verificationStatus ==="PENDING" ?  <FaEye
                          className="me-2"
                          style={{ cursor: "pointer", color: "orange" }}
                          onClick={() => handleEdit(notification)}
                        />
                    :`${notification.verificationStatus}`
                    }
                        
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No Data Available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

             <div className="row mt-4" style={{ "--bs-gutter-x": "0rem" }}>
                        <div className="col-5">
                          {totalItems > 0
                            ? `Showing ${startIndex + 1}-${endIndex} of ${totalItems}`
                            : "No items to display"}
                        </div>
                        <div className="col-7 d-flex justify-content-end">
                          <div className="d-flex align-items-center">
                            <button
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                              }}
                              className="btn btn-success d-flex align-items-center justify-content-center"
                              onClick={handlePreviousPage}
                              disabled={currentPage === 1}
                            >
                              <FaAngleLeft />
                            </button>
            
                            <div className="mx-3 d-flex">
                              {getPageNumbers(currentPage, totalPages).map(
                                (pageNum, index) =>
                                  pageNum === "..." ? (
                                    <span key={`ellipsis-${index}`} className="mx-1">
                                      ...
                                    </span>
                                  ) : (
                                    <button
                                      key={pageNum}
                                      className={`btn mx-1 ${
                                        currentPage === pageNum
                                          ? "active btn-primary"
                                          : "btn-light"
                                      }`}
                                      onClick={() => handlePageChange(pageNum)}
                                    >
                                      {pageNum}
                                    </button>
                                  )
                              )}
                            </div>
            
                            <button
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                              }}
                              className="btn btn-success d-flex align-items-center justify-content-center"
                              onClick={handleNextPage}
                              disabled={currentPage >= totalPages}
                            >
                              <FaAngleRight />
                            </button>
                          </div>
                        </div>
                      </div>
                        </div>
                     
          </div>

          {/* View Modal */}
          <Modal
            isOpen={isViewModalOpen}
            toggle={() => setIsViewModalOpen(false)}
            centered
          >
            <ModalHeader toggle={() => setIsViewModalOpen(false)}>
              View Notification
            </ModalHeader>
            <ModalBody>
              {currentNotification && (
                <>
                  <h5>{currentNotification.title}</h5>
                  <iframe
                    src={currentNotification.file}
                    title="Notification File"
                    style={{ width: "100%", height: "350px" }}
                  ></iframe>
                </>
              )}
            </ModalBody>
          </Modal>

          {/* Edit Modal */}
          <Modal
            isOpen={isEditModalOpen}
            toggle={() => setIsEditModalOpen(false)}
            centered
          >
            <ModalHeader toggle={() => setIsEditModalOpen(false)}>
              Edit Notification
            </ModalHeader>
            <ModalBody>
              <div className="mb-3">
                <label className="form-label">Location</label>
                <select
                  className="form-select"
                  value={currentNotification?.location || ""}
                  onChange={(e) =>
                    setCurrentNotification((prev) => ({
                      ...prev,
                      location: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Location</option>
                  {locations.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label htmlFor="editTitle" className="form-label">
                  Title
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="editTitle"
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                  placeholder="Enter notification title"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Upload New File (PDF only)</label>
                <input
                  type="file"
                  className="form-control"
                  ref={fileInputRef}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="editLink" className="form-label">
                  Link
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="editLink"
                  value={editLink}
                  onChange={(e) => setEditLink(e.target.value)}
                  placeholder="Enter notification Link"
                />
              </div>
            </ModalBody>
            <ModalFooter className="flex-nowrap">
              <Button color="success" onClick={handleEditSave}>
                Save Changes
              </Button>
              <Button
                color="secondary"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>
  
  );
};

export default RegistrationFilter;
